import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import { CurrencyEnum } from './enum';

export const queryString = (obj: Object = {}) => {
    var parts = [];
    for (var key in obj) {
        if (typeof obj[key] == 'object') {
            for (var key2 in obj[key]) {
                parts.push(`${encodeURIComponent(key)}[${encodeURIComponent(key2)}]` + '=' + encodeURIComponent(obj[key][key2]));
            }
        } else {
            parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key].toString()));
        }
    }
    return parts.join('&');
}

export const toCamelCase = (str: string) => {
    str = str.replace(/[-_\s.]+(.)?/g, (_, c) => c ? c.toUpperCase() : '');
  
    return str.substring(0, 1).toLowerCase() + str.substring(1);
}

export const phoneNumberFormat = (num: any) => {
    try {
        if (num) {
            return parsePhoneNumber(num).formatInternational();
        }
    } catch {}

    return num;
};

export const formatBytes = (bytes: number, decimals: number = 2) => {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export const convertFileToBase64 = (file:File):Promise<string> => {
    return new Promise<string> ((resolve,reject)=> {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result?.toString() || '');
        reader.onerror = error => reject(error);
    });
}

export const clearEmptyAttributes=(data)=>{
    Object.keys(data).forEach(key => ((!data[key] || data[key].length === 0)) ? delete data[key] : {});
}

export const clearEmptyNaNAttributes=(data)=>{
    Object.keys(data).forEach(key => ((!data[key] || data[key].length === 0) && isNaN(data[key])) ? delete data[key] : {});
}

export const attributesToCamilCase = (data)=>{
    Object.keys(data).forEach(key => {
        data[toCamelCase(key)] = data[key];
        if (key.includes("_"))
            delete data[key];
    });
}

export const trasformDateString = (date) => {
    if (typeof date === "string" || typeof date === "undefined") {
        return date;
    }
    else if (date == null) {
        return "";
    }
    else {
        return (date as Date).toISOString()
    }
}


export const priceFormatRevevrse = (price) => {
    let formattedPrice = parseFloat(price);
    if (!formattedPrice || isNaN(formattedPrice)) {
        return '';
    }

    return Number((formattedPrice*100).toFixed());
}

export const phonePattern = /^(?:\+?(\d{1,3})){1}[ ]{0,1}(\d{2,3}){1}[ ]{0,1}(\d{3}){1}[ ]{0,1}(\d{4,8}){1}\s{0}$/ 

export const priceFormat = ( price, currencyField) => {
    if((!price && price !== 0) || isNaN(price))
        return '';

    const currency = CurrencyEnum.find(ele=> ele.id === currencyField ?? "USD")

    const formattedPrice = (price / 100).toLocaleString('de-DE', {
        style: 'currency',
        currency: currency.id,
    });

    if(currency.id == "USD" || currency.id == "EUR")
        return formattedPrice || '0,00 '+currency.symbol
    else
        return currency.symbol+formattedPrice
}

export const dateStringFormat = (date) => {
    return date.substring(0, 10).replaceAll("-", "/")
}


export const formatDateTime = (datetime: any) => {
    if (null === datetime || typeof datetime == "undefined") {
        return null;
    }

    return new Date(datetime).toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hourCycle: 'h12',
        hour: '2-digit',
        minute: '2-digit',
    })
};

export const formatDate = (date: any) => {
    if (null === date || typeof date == "undefined") {
        return null;
    }

    return new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    })
};

export const insertIntoArray = (arr, index, newItem) => [
    ...arr.slice(0, index),
    newItem,
    ...arr.slice(index)
]

export const capitalize = (str) => {
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
}

export const toDataURL = url => fetch(url, { 
    method: "GET",
    headers: {
        "Accept": "*/*"
    } 
}).then(response => response.blob())
.then(blob => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
}))

export const isExternalUrl = (url) => {
    try {
      const parsed = new URL(url);
      return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
      return false; // relative or invalid URL
    }
}